import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { AuthService } from "../services/auth";
import { useI18n } from "../i18n";
import ThemeToggle from "./ThemeToggle";
import LanguageToggle from "./LanguageToggle";
import { FamflixMark, UserIcon, ChevronIcon } from "./icons";

export default function Header() {
  const auth = useAuth();
  const { t } = useI18n();
  const [menuOpen, setMenuOpen] = useState(false);

  const userProfile = AuthService.getUserProfile(auth);
  const email = userProfile.email;
  const groups = userProfile["cognito:groups"] || [];

  const handleSignOut = async () => {
    try {
      await AuthService.signOut();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <header className="navbar bg-base-100 border-b border-base-300 px-3 sm:px-4">
      <div className="flex-1 flex items-center gap-2.5">
        <span className="text-primary">
          <FamflixMark className="w-8 h-8" />
        </span>
        <span className="text-xl font-bold tracking-tight font-display">
          {t("header.title")}
        </span>
      </div>

      <div className="flex-none flex items-center gap-1">
        <LanguageToggle />
        <ThemeToggle />
        <div className="relative">
          <button
            className="btn btn-ghost btn-sm gap-2 max-w-[55vw]"
            onClick={() => setMenuOpen((open) => !open)}
            aria-haspopup="true"
            aria-expanded={menuOpen}
          >
            <UserIcon className="w-5 h-5 opacity-70" />
            <span className="truncate hidden sm:inline">{email}</span>
            <ChevronIcon
              className={`w-4 h-4 opacity-50 transition-transform ${
                menuOpen ? "rotate-180" : ""
              }`}
            />
          </button>

          {menuOpen && (
            <>
              <div
                className="fixed inset-0 z-[900]"
                onClick={() => setMenuOpen(false)}
              ></div>
              <div className="absolute right-0 mt-2 w-64 bg-base-100 rounded-box p-3 z-[1000] border border-base-300 shadow-lg">
                <div className="px-1 pb-2 mb-2 border-b border-base-300">
                  <p className="text-xs opacity-60">{t("header.signedInAs")}</p>
                  <p className="text-sm font-medium truncate">{email}</p>
                </div>
                {groups.length > 0 && (
                  <>
                    <p className="text-xs opacity-60 px-1 mb-1">
                      {t("header.yourGroups")}
                    </p>
                    <div className="flex flex-wrap gap-1 px-1 mb-3">
                      {groups.map((group) => (
                        <span
                          key={group}
                          className="badge badge-sm badge-ghost"
                        >
                          {group}
                        </span>
                      ))}
                    </div>
                  </>
                )}
                <button
                  className="btn btn-ghost btn-sm w-full justify-start"
                  onClick={handleSignOut}
                >
                  {t("common.signOut")}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
